import "./dataset.f56cc6d6.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefddd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefddd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $k4QTz = parcelRequire("k4QTz");

var $aNTv2 = parcelRequire("aNTv2");

var $cXHfx = parcelRequire("cXHfx");

var $axctD = parcelRequire("axctD");

var $eR6SU = parcelRequire("eR6SU");

var $jDulA = parcelRequire("jDulA");
(async ()=>{
    try {
        await window.i18nReady;
        // Obtain update_time
        const update_time = await (0, $jDulA.default).update_time.get_update_time();
        $cXHfx.update_update_time_display(update_time);
        // Load the Daily Stats Data
        const update_month = update_time.slice(0, 7);
        let stats_data = await $cXHfx.load_daily_stats_data(update_month);
        // Init elements
        await $3fc40f1b95d7c86f$var$generate_top_data(stats_data);
        $3fc40f1b95d7c86f$var$set_first_column_active();
        $3fc40f1b95d7c86f$var$initialize_carousel();
        await (0, $axctD.default).cards.main_card(stats_data);
        // Hide the loading overlay
        (0, $axctD.default).spinner.hideSpinner("loadingOverlay");
    } catch (error) {
        console.log(error);
    }
})();
async function $3fc40f1b95d7c86f$var$generate_top_data(stats_data) {
    for(let column in $aNTv2.dataset_all_mapping){
        let count_method = 'count';
        if (column === 'resources_formats') count_method = 'presence';
        await (0, $eR6SU.default).progress_bar.generate_progress_bar_carousel_item(stats_data, 'test', column, count_method, $aNTv2.dataset_all_mapping);
    }
}
function $3fc40f1b95d7c86f$var$set_first_column_active() {
    const first_col_id = 'top_' + Object.keys($aNTv2.dataset_all_mapping)[0] + '_item';
    const first_col = document.getElementById(first_col_id);
    first_col.classList.add('active');
}
function $3fc40f1b95d7c86f$var$initialize_carousel() {
    const myCarouselElement = document.querySelector('#top_data_carousel');
    const carousel = new $k4QTz.Carousel(myCarouselElement, {
        interval: 2000,
        touch: false
    });
}


//# sourceMappingURL=public.cb929172.js.map
